import * as React from "react";
import { IconProps } from "../types";

const DotsGridIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        width="13"
        height="12"
        fill="none"
        viewBox="0 0 13 12"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
        {...props}
      >
        <path
          d="M4.5 7C5.05228 7 5.5 6.55228 5.5 6C5.5 5.44772 5.05228 5 4.5 5C3.94772 5 3.5 5.44772 3.5 6C3.5 6.55228 3.94772 7 4.5 7Z"
          fill={color}
        />
        <path
          d="M4.5 3C5.05228 3 5.5 2.55228 5.5 2C5.5 1.44772 5.05228 1 4.5 1C3.94772 1 3.5 1.44772 3.5 2C3.5 2.55228 3.94772 3 4.5 3Z"
          fill={color}
        />
        <path
          d="M4.5 11C5.05228 11 5.5 10.5523 5.5 10C5.5 9.44772 5.05228 9 4.5 9C3.94772 9 3.5 9.44772 3.5 10C3.5 10.5523 3.94772 11 4.5 11Z"
          fill={color}
        />
        <path
          d="M8.5 7C9.05228 7 9.5 6.55228 9.5 6C9.5 5.44772 9.05228 5 8.5 5C7.94772 5 7.5 5.44772 7.5 6C7.5 6.55228 7.94772 7 8.5 7Z"
          fill={color}
        />
        <path
          d="M8.5 3C9.05228 3 9.5 2.55228 9.5 2C9.5 1.44772 9.05228 1 8.5 1C7.94772 1 7.5 1.44772 7.5 2C7.5 2.55228 7.94772 3 8.5 3Z"
          fill={color}
        />
        <path
          d="M8.5 11C9.05228 11 9.5 10.5523 9.5 10C9.5 9.44772 9.05228 9 8.5 9C7.94772 9 7.5 9.44772 7.5 10C7.5 10.5523 7.94772 11 8.5 11Z"
          fill={color}
        />
      </svg>
    );
  },
);

export default DotsGridIcon;
